import {
  IPrescriptionModule,
  ManualPrescriptionObject,
  UploadPrescriptionObject,
  PrescriptionObject,
} from '@/scripts/libs/rox-lens-panel/types/PrescriptionModule'
import { Frame } from '@/scripts/libs/rox-lens-panel/types/RoxLensPanel'
import Prescription from '@/scripts/libs/prescription'
import wcs from '@/scripts/libs/wcs'
const { checkPrescriptionIssueDate, manualInput, showDoctorName } = wcs.getStoreConfig()

export class PrescriptionModule implements IPrescriptionModule {
  private getMaxFileSize = (): number => {
    const fileSize = manualInput?.maxUploadSizeInBytes

    const bytes = parseInt(fileSize, 10)
    const megabytes = bytes / (1024 * 1024)
    return megabytes || 0
  }

  prescriptionType = 'FULL'
  prescriptionFlows: string[] = Prescription.mapPrescriptionFlowsFromCookies()
  fileExtensions = manualInput?.supportedFileExtension?.split(',')
  maxFileSize = this.getMaxFileSize()
  hideMoreOptions = false
  enablePrismComment = false
  enablePrism = Prescription.enablePrism()
  checkPrescriptionIssueDate = Number(checkPrescriptionIssueDate)
  showdoctorName = showDoctorName

  //TODO: check if this method is needed
  loadPrescription = () => {
    return new Promise<ManualPrescriptionObject>((resolve) => {
      resolve({} as ManualPrescriptionObject)
    })
  }
  savePrescription = (_prescriptionObject: ManualPrescriptionObject) => {
    //TODO: handle return success
    return true
  }
  //TODO: check if this method is needed
  checkAvailableFrames = (_frame: Frame, _prescriptionObject: ManualPrescriptionObject) => {
    return null
  }
  clearPrescription = () => {
    Prescription.clearPrescriptionInStorage()
    return true
  }
  loadExtendedPrescription = () => {
    return new Promise<PrescriptionObject | null>((resolve) => {
      const prescriptionObjectInStorage = Prescription.getPrescriptionInStorage()
      if (!prescriptionObjectInStorage) {
        resolve(null)
      }
      resolve(prescriptionObjectInStorage)
    })
  }
  // THIS IS ONLY FOR UPLOAD FLOW, save the uploaded file
  uploadExtendedPrescription = (requestObject: UploadPrescriptionObject) => {
    requestObject.savedFileName = requestObject.fileName
    requestObject.prescriptionId = requestObject.prescriptionId || 12345
    return new Promise<UploadPrescriptionObject>((resolve) => {
      Prescription.savePrescriptionInStorage(requestObject)
      resolve(requestObject)
    })
  }
  // THIS IS FOR BOTH UPLOAD AND MANUAL FLOW, save the prescription object
  saveExtendedPrescription = (prescriptionObject: PrescriptionObject) => {
    //TODO: handle manual prescription scenario
    const prescriptionFileInSessionStorage = Prescription.getPrescriptionInStorage()
    if (
      prescriptionFileInSessionStorage &&
      Prescription.isUploadPrescriptionObject(prescriptionFileInSessionStorage) &&
      Prescription.isUploadPrescriptionObject(prescriptionObject)
    ) {
      prescriptionObject.fileData = prescriptionFileInSessionStorage.fileData
    }

    return new Promise<PrescriptionObject>((resolve) => {
      Prescription.savePrescriptionInStorage(prescriptionObject)
      resolve(prescriptionObject)
    })
  }
  //TODO: set empty prescription in sessionStorage (for Manual FLOW)
  clearExtendedPrescription = () => {
    Prescription.clearPrescriptionInStorage()
    return new Promise<Record<string, never>>((resolve) => {
      resolve({})
    })
  }
  downloadExtendedPrescription = () => {
    return new Promise<UploadPrescriptionObject>((resolve) => {
      const uploadedPrescriptionImage = Prescription.getPrescriptionInStorage()
      resolve(uploadedPrescriptionImage as UploadPrescriptionObject)
    })
  }
}
